// extracted by mini-css-extract-plugin
export default {"modalNoHeader":"modalNoHeader-BwHA3","modal":"modal-v1MH7"};